import { DataGridActiveColumns } from '@virtus/components/DataGrid/models';

export const TraceDetailsActiveColumns: DataGridActiveColumns = {
  timestamp: true,
  message: true,
  name: true,
  roleInstance: true,
};

export const TraceDetailsBaseColumns = {
  timestamp: {
    field: 'timestamp',
    filterPlaceholder: 'Search TimeStamp',
    width: 170,
    Filter: 'DateFilter',
  },
  message: {
    field: 'message',
    filterPlaceholder: 'Search Message',
    width: 240,
  },
  name: {
    field: 'name',
    filterPlaceholder: 'Search Name',
    width: 240,
  },
  roleInstance: {
    field: 'roleInstance',
    filterPlaceholder: 'Search roleInstance',
    width: 130,
  },
};

export const TraceHeaders = [
  {
    caption: 'Trace Time',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'timestamp',
    dataType: 'string',
    width: '40%',
  },
  {
    caption: 'Message',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'message',
    dataType: 'string',
    width: '80%',
  },
  {
    caption: 'Name',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'name',
    dataType: 'string',
    width: '80%',
  },
  {
    caption: 'Role Instance',
    allowFiltering: true,
    alignment: 'left',
    dataField: 'roleInstance',
    dataType: 'string',
    width: '40%',
  },
];
